import React from "react";
import withShipment from "../../withShipment";

import {FTL_COST_PAGES} from "./constants";
import PropTypes from "prop-types";
import ErrorFeedbackBar from "../global/ErrorFeedbackBar";
import FTLCostsTable from "./ftlCostsPages/FTLCostsTable";
import {ftlCostsSelector} from "../../redux/selectors/ftlCosts";
import {listFTLCosts} from "../../redux/actions/ftlCosts";
import { selectedLocationIdSelector, userInfoSelector } from '../../redux/selectors/auth';
import {listAvailableLocations} from "../../redux/actions/settings";
import {availableLocationsSelector} from "../../redux/selectors/settings";
import { automationInfoSelector } from '../../redux/selectors/account';
import { getCompany, updateCompany } from '../../redux/actions/automationRules';

class FTLCosts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: FTL_COST_PAGES.TABLE
        }

    }

    componentDidMount() {
        this.props.listAvailableLocations()
        this.props.listFTLCosts()
        this.props.getCompany()
    }
    setCurrentPage = (newPage) => {
        this.setState({
            currentPage: newPage
        })
    }

    displayTable = () => {
        return <React.Fragment>
            <FTLCostsTable
                setCurrentPage={this.setCurrentPage}
                tableRows={this.props.ftlCosts}
                selectedLocation={this.props.selectedLocation}
                locations={this.props.availableLocations}
                automationSettings={this.props.automationSettings}
                updateCompany={this.props.updateCompany}
                user={this.props.user}
                availableLocations={this.props.availableLocations}
            />
        </React.Fragment>
    }


    displayCurrentPage = (currentPage) => {
        switch (currentPage) {
            case FTL_COST_PAGES.TABLE:
                return this.displayTable()
            default:
                console.log("Error: current FTL costs page doesn't exist")
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }

    render() {
        return (
            <React.Fragment>
                <ErrorFeedbackBar/>
                {this.displayCurrentPage(this.state.currentPage)}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    ftlCosts: ftlCostsSelector(state),
    availableLocations: availableLocationsSelector(state),
    selectedLocation: selectedLocationIdSelector(state),
    automationSettings: automationInfoSelector(state),
    user: userInfoSelector(state),
})

const actionCreators = {
    listAvailableLocations,
    listFTLCosts,
    getCompany,
    updateCompany,
}

FTLCosts.propTypes = {
    ftlCosts: PropTypes.array,
    availableLocations: PropTypes.array
}

FTLCosts.defaultProps = {
    ftlCosts: [],
    availableLocations: []
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, FTLCosts);